import { cn } from "@utils/ui";

import { useFieldContext } from "..";
import { Checkbox } from "../../ui/checkbox";
import { Label } from "../../ui/label";

type CheckboxFieldProps = {
  label: string;
  labelClassName?: string;
  className?: string;
};

export const CheckboxField = ({
  label,
  labelClassName,
  className,
}: CheckboxFieldProps) => {
  const field = useFieldContext<boolean>();

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Checkbox
        id={field.name}
        checked={field.state.value}
        onCheckedChange={(checked) => field.handleChange(checked === true)}
        onBlur={field.handleBlur}
      />
      <Label
        htmlFor={field.name}
        className={cn("text-sm font-normal text-foreground-muted", labelClassName)}
      >
        {label}
      </Label>
    </div>
  );
};
